import { useTranslation } from 'react-i18next';
import CircularLoader from '../../../components/CircularLoader/CircularLoader';
import ChatStyles from '../Chat.module.css';
import PrevChatUserSkeleton from '../../../components/Skeletons/PrevChatUserSkeleton';
import AddGroupUsersStyles from '../GroupChatScreen/AddGroupUsersModal/AddGroupUsersMoal.module.css';

const SentRequests = ({
  topBorder,
  cardListRef3,
  prevSentSearch,
  setPrevSentSearch,
  notAcceptedUsersSearch,
  prevSentRequestLoading,
  prevSentRequests,
  handleRemoveRequest,
  notAcceptedCircularLoader,
  style,
  searchBoxStyles,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ padding: '14px 18px 6px', borderTop: topBorder ? '1px solid #e2e8f0' : 'unset', borderBottom: '1px solid #f1f5f9', ...searchBoxStyles }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 10 }}>{t('screens.chat.sentRequestsHeader')}</div>
        <div className={ChatStyles.convSearch}>
          <svg className={ChatStyles.convSearchIcon} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <circle cx='11' cy='11' r='8' />
            <path d='M21 21l-4.35-4.35' />
          </svg>
          <input
            className={ChatStyles.convSearchInput}
            placeholder={t('screens.chat.searchSent')}
            value={prevSentSearch}
            onChange={e => {
              setPrevSentSearch(e.target.value);
              notAcceptedUsersSearch(e.target.value);
            }}
          />
        </div>
      </div>
      <div ref={cardListRef3} style={style}>
        {prevSentRequestLoading ? (
          <PrevChatUserSkeleton />
        ) : prevSentRequests?.data?.length === 0 ? (
          <div className={AddGroupUsersStyles.emptyList}>
            <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
              <circle cx='9' cy='7' r='4' />
            </svg>
            <span>{t('screens.chat.noSentRequests')}</span>
          </div>
        ) : (
          prevSentRequests?.data
            ?.filter(u => u.name.toLowerCase().includes(prevSentSearch.toLowerCase()))
            .map(user => (
              <div key={user._id} className={ChatStyles.chatLists_user}>
                <div className={ChatStyles.chatLists_user_imageBox}>
                  <img src='/assets/indviual.png' alt='User' className={ChatStyles.chatLists_user_image} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={ChatStyles.chatLists_user_name}>{user.name}</div>
                  <div className={ChatStyles.chatLists_user_email}>{user.email}</div>
                  <div className={ChatStyles.chatLists_user_req_btns}>
                    <button className={ChatStyles.chatLists_user_can_btn} onClick={() => handleRemoveRequest(user._id)}>
                      {t('screens.chat.remove')}
                    </button>
                  </div>
                </div>
              </div>
            ))
        )}
        {notAcceptedCircularLoader && (
          <div className={ChatStyles.circularLoader}>
            <CircularLoader />
          </div>
        )}
      </div>
    </>
  );
};

export default SentRequests;
